export const validateToken = async ({ token, user, condominio }) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/auth/validate-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ user, condominio }),
      }
    );

    if (!response.ok) {
      throw new Error(`Erro ao validar token. Status: ${response.status}`);
    }

    const data = await response.json();

    const { role, password, ...filteredUser } = data.user;
    const userWithToken = { ...filteredUser, token };

    return { user: userWithToken, condominio: data.condominio };
  } catch (error) {
    throw error;
  }
};